(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ServiceAddOn', ServiceAddOn);

    ServiceAddOn.$inject = ['$resource'];

    function ServiceAddOn($resource) {
        var resourceUrl = 'api/service-add-ons/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
